import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M25 28H7v-2H5v2a2 2 0 002 2h18a2 2 0 002-2v-2h-2zM26.42 8.43l-5.83-5.84A2 2 0 0019.18 2H7a2 2 0 00-2 2v9h2V4h11v5a2 2 0 002 2h5v2h2V9.84a2 2 0 00-.58-1.41z"/><path d="M28 13H4a2 2 0 00-2 2v9a2 2 0 002 2h24a2 2 0 002-2v-9a2 2 0 00-2-2zm-15.9 5h-1.31v4.12h-1.4V18H8.08v-1.17h4zm4.9 4.16l-1-1.68-1 1.68h-1.62l1.78-2.71-1.68-2.62h1.58l.94 1.68.94-1.68h1.68l-1.68 2.71 1.77 2.62zM23.92 18h-1.31v4.12h-1.4V18H19.9v-1.17h4z"/>';
export var FileTextSVG = function FileTextSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
FileTextSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FileTextSVG);